import { ScoreSummary, Statistics } from '../components';

export default function Dashboard() {
    return (
        <>
            <ScoreSummary />
            <Statistics />
        </>
    );
}
